import HomePage from '../pages/HomePage';
import DepartamentosPage from '../pages/DepartamentosPage';
import MisRecursosPage from '../pages/MisRecursosPage';
import MisMateriasPage from '../pages/MisMateriasPage';
import RecursosPage from '../pages/RecursosPage';
import AuditoriaPage from '../pages/AuditoriaPage';
import LoginPage from '../pages/LoginPage';
import ProtectedRoute from '../components/ProtectedRoute';
import { Route, Routes, Navigate } from 'react-router-dom';
import { EUserRole } from '../types/user';

import { LOGIN, ROOT, DEPARTAMENTOS, MIS_RECURSOS, MIS_MATERIAS, RECURSOS, AUDITORIA } from './constants';

// TODO: Refactor this in the future once we have all pages
const DEPARTAMENTOS_ROLES = [EUserRole.ADMINISTRADOR];
const MIS_RECURSOS_ROLES = [EUserRole.DOCENTE];
const MIS_MATERIAS_ROLES = [EUserRole.ALUMNO];
const RECURSOS_ROLES = [EUserRole.AUDITOR, EUserRole.ADMINISTRADOR];
const AUDITORIA_ROLES = [EUserRole.ADMINISTRADOR];

function RouterConfig() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={LOGIN} replace />} />
      <Route path={LOGIN} element={<LoginPage />} />

      <Route
        path={ROOT}
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path={DEPARTAMENTOS}
        element={
          <ProtectedRoute allowedRoles={DEPARTAMENTOS_ROLES}>
            <DepartamentosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={MIS_RECURSOS}
        element={
          <ProtectedRoute allowedRoles={MIS_RECURSOS_ROLES}>
            <MisRecursosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={MIS_MATERIAS}
        element={
          <ProtectedRoute allowedRoles={MIS_MATERIAS_ROLES}>
            <MisMateriasPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={RECURSOS}
        element={
          <ProtectedRoute allowedRoles={RECURSOS_ROLES}>
            <RecursosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={AUDITORIA}
        element={
          <ProtectedRoute allowedRoles={AUDITORIA_ROLES}>
            <AuditoriaPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to={LOGIN} replace />} />
    </Routes>
  );
}

export default RouterConfig;
